export default "__VITE_ASSET__Dbg6Bva3__"